import {
    useLayoutEffect,
    useState,
    type FC
} from "react";
import {
    Animated
} from "react-native";
import type IQuestionnaireSwapProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAnimatedState,
    useReducedMotion,
    getSlideStyle
} from "../../../../helpers/motion";
import {
    getQuestionnaireSwapOffset
} from "../../util";

const QuestionnaireSwap: FC<IQuestionnaireSwapProps> = ({
    customTheme,
    children,
    step
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    const isReduceMotionEnabled = useReducedMotion();

    const [
        swapStep,
        setSwapStep
    ] = useState(step);

    const [
        isEntered,
        setIsEntered
    ] = useState(step === 0);

    const progress = useAnimatedState({
        onFinish: () => setSwapStep(0),
        value: isEntered ? 1 : 0,
        intent: "contentSwap",
        motion: "fade",
        customTheme
    });

    useLayoutEffect(() => {
        setIsEntered(true);
    }, []);

    const swapDynamicStyle = getSlideStyle({
        offset: getQuestionnaireSwapOffset({
            step: swapStep,
            direction,
            spaces
        }),
        isReduceMotionEnabled,
        axis: "x",
        progress
    });

    return <Animated.View
        style={[
            stylesheet.container,
            swapDynamicStyle
        ]}
    >
        {children}
    </Animated.View>;
};
export default QuestionnaireSwap;
